var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMingcuteBankCardFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4985 7.5V12.75C17.4985 13.3467 17.2615 13.919 16.8395 14.341C16.4176 14.7629 15.8453 15 15.2485 15H4.74853C4.1518 15 3.5795 14.7629 3.15754 14.341C2.73559 13.919 2.49854 13.3467 2.49854 12.75V7.5H17.4985ZM14.4985 10.5H12.2485C12.0496 10.5 11.8589 10.579 11.7182 10.7197C11.5776 10.8603 11.4985 11.0511 11.4985 11.25C11.4985 11.4489 11.5776 11.6397 11.7182 11.7803C11.8589 11.921 12.0496 12 12.2485 12H14.4985C14.6974 12 14.8882 11.921 15.0289 11.7803C15.1695 11.6397 15.2485 11.4489 15.2485 11.25C15.2485 11.0511 15.1695 10.8603 15.0289 10.7197C14.8882 10.579 14.6974 10.5 14.4985 10.5ZM15.2485 3C15.8453 3 16.4176 3.23705 16.8395 3.65901C17.2615 4.08097 17.4985 4.65326 17.4985 5.25V6H2.49854V5.25C2.49854 4.65326 2.73559 4.08097 3.15754 3.65901C3.5795 3.23705 4.1518 3 4.74853 3H15.2485Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.998535)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteBankCardFill);
export default __webpack_public_path__ + "static/media/mingcute_bank-card-fill.d1e44bd3ed8f700e3f3d71e41c71202b.svg";
export { ForwardRef as ReactComponent };